import { ExportColumn } from '../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: 'Division',
    type: 'text',
    width: 45,
  },
  {
    key: 'locationsPerDivision',
    header: 'Location Count',
    type: 'number',
    width: 45,
  },
  {
    key: 'divisionMitigationAverage',
    header: 'Division Mitigation Average',
    type: 'money',
    width: 45,
  },
];

export const baseColumnsMitigation: ExportColumn[] = [
  {
    key: 'locationName',
    header: 'Location',
    type: 'text',
    width: 30,
  },
  {
    key: 'rebuildTime',
    header: 'Rebuild Time (months)',
    type: 'number',
    width: 35,
  },
  {
    key: 'unmitigatedRevenueExposed',
    header: 'Unmitigated Revenue Exposed',
    type: 'money',
    width: 35,
  },
  {
    key: 'availableFgMitigation',
    header: 'Finished Goods Mitigation',
    type: 'money',
    width: 35,
  },
  {
    key: 'availableInternalMitigation',
    header: 'Available Internal Mitigation',
    type: 'money',
    width: 35,
  },
  {
    key: 'availableExternalMitigation',
    header: 'Available External Mitigation',
    type: 'money',
    width: 35,
  },
  {
    key: 'combinedMitigation',
    header: 'Combined Mitigation',
    type: 'money',
    width: 35,
  },
  {
    key: 'mitigationPercentage',
    header: 'Mitigation %',
    type: 'percentage',
    width: 35,
  },
  {
    key: 'netRevenueExposure',
    header: 'Net Revenue Exposure',
    type: 'money',
    width: 35,
  },
];
